import Link from 'gatsby-link';
import React, { Component } from 'react';
import Zoom from 'react-reveal/Zoom';
import { Button, Container, Grid, Header, Image, Responsive } from 'semantic-ui-react';

import BasicContainer from './BasicContainer';

const uuidv4 = require('uuid/v4');
const clients = [
  {src:require('../assets/img/clients/frameblender.png'),url:'http://www.frameblenderfilms.com/'},
  {src:require('../assets/img/clients/loveunique.png'),url:'http://loveuniquestudios.com/'},
  {src:require('../assets/img/clients/tylerlindsey.jpg'),url:'https://www.tylerandlindsey.com/'}
]
const clientText = 'AND MANY MORE. We respect the confidentiality of information of our clients, and will never disclose their information without permission.'

export default class Clients extends Component {
    render(){
        return (
          <div>
            <BasicContainer>
              <Zoom>
              <Responsive minWidth={Responsive.onlyTablet.minWidth}>
              <Header content="Our Clients" className="mpost-header--huge" textAlign="center" />
              </Responsive>
              <Responsive {...Responsive.onlyMobile}>
              <Header content="Our Clients" className="mpost-header--huge mobile" textAlign="center" />
              </Responsive>
              <div className="mpost-header--divider" />
              <Container textAlign="center">
                <Grid centered style={{ maxWidth: '800px', margin: '0 auto' }}>
                  {clients.map(client => (
                    <Grid.Column verticalAlign="middle" mobile={16} computer={4} largeScreen={4} key={uuidv4()}>
                      <Image src={client.src} as="a" href={client.url} centered size="large" className="mpost-client-logo" />
                    </Grid.Column>
                  ))}
                </Grid>
                <div>
                <Responsive minWidth={Responsive.onlyTablet.minWidth}>
                <p className="mpost-p" style={{marginTop: '2rem', textAlign:'center'}}>{clientText}</p>
                </Responsive>
                <Responsive {...Responsive.onlyMobile}>
                <p className="mpost-p mobile" style={{marginTop: '2rem', textAlign:'center'}}>{clientText}</p>
                </Responsive>
              {this.props.testimony&&<Button as={Link} to="testimonies/" content="Testimonies" className="mpost-button" />}
              </div>
              </Container>
              </Zoom>



              
            </BasicContainer>
        </div>
      )
    }
}



// WEBPACK FOOTER //
// ./src/components/Clients.js